import React from 'react'
import {Form, Submit} from './styled';
import Container from '../../components/Container';
import Input from '../../components/Form/Input';
import useForm from '../../hooks/useForm';
import Button from '../../components/Button';
import { UserContext } from '../../UserContext';
import { api } from '../../services/api';
import Alert from '../../components/Alert';

const ChangePassword: React.FC = () => {
    document.title = "Alterar Senha - Sultan Veste a Casa";

    const [success, setSuccess] = React.useState("");
    const [error, setError] = React.useState("");

    const password_now = useForm('password');
    const password_new = useForm('password');
    const password_new_confirmation = useForm('password');

    const {loading, setLoading} = React.useContext(UserContext);
  
    const onSave = async (e: React.FormEvent) => {
        e.preventDefault();

        try{
            setLoading(true);

            await api.put('user/password', {
                password_now: password_now.value,
                password_new: password_new.value,
                password_new_confirmation: password_new_confirmation.value
            });

            setSuccess('Senha alterada com sucesso!');

            password_now.setValue('');
            password_new.setValue('');
            password_new_confirmation.setValue('');
        }catch(error){
            const result = (error as Error).message;
            setError(result);
        }finally{
            setLoading(false);
        }
    }

    const handleMessageSuccess = () => {
        setSuccess("");
    }

    const handleMessageError = () => {
        setError("");
    }

    return (
        <Container style={{minHeight: 'calc(100vh - 240px)', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <Form className="shadow" onSubmit={onSave}>                                                                                            
                <Input 
                    label="Senha atual: *" 
                    required 
                    id="password_now"
                    type="password" 
                    placeholder="******"
                    {...password_now}
                />
                <Input 
                    label="Senha Nova: *" 
                    required id="password"
                    type="password" 
                    placeholder="******"
                    {...password_new}
                />                
                <Input 
                    label="Confirme a Nova Senha: *" 
                    required 
                    id="password_confirm"
                    type="password" 
                    placeholder="******"
                    {...password_new_confirmation}
                />
                <Submit>
                    {loading ? 
                        <Button type="submit" disabled>Carregando...</Button> 
                    :
                        <Button type="submit">Trocar Senha</Button>}
                </Submit>                                                                                                                        
            </Form>           
            <Alert open={success !== ''} onClose={handleMessageSuccess} severity="success" message={success}/>                                                                       
            <Alert open={error !== ''} onClose={handleMessageError} severity="error" message={error}/>                                                                       
        </Container>        
    )
}

export default ChangePassword;